import React from 'react';
import PropTypes from 'prop-types';

import {
  QuestionLabel,
  Container,
} from '../styles';

import { AnswerField } from './styles';

const WrittenQuestionType = (props) => {
  const {
    label,
    index,
    writtenAnswer,
  } = props;

  return (
    <Container>
      <QuestionLabel>{`Question ${index + 1}: ${label} (Written Response)`}</QuestionLabel>
      <AnswerField value={writtenAnswer} disabled />
    </Container>
  );
};

WrittenQuestionType.propTypes = {
  label: PropTypes.string.isRequired,
  index: PropTypes.number,
  writtenAnswer: PropTypes.string,
};

WrittenQuestionType.defaultProps = {
  index: null,
  writtenAnswer: '',
};

export default WrittenQuestionType;
